export enum ActionInventory {
  creation = "creation",
  update = "update",
  delete = "delete",
}
